import { GoogleTagManager } from '@next/third-parties/google';
import { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { CookiesPopup } from '@r-and-a-shared-ui/common-ui';
import {
  getWebsiteStructuredData,
  isPreviewFromEnv,
} from '@r-and-a-shared-ui/utils';
import useSchemaOrg from '../../../hooks/useSchemaOrg';

export const PlayerPortalsConfiguration = ({
  siteSettings,
}: {
  siteSettings?: PLAYER_PORTALS_MODELS.PlayerPortalsConfiguration | any;
}) => {
  useSchemaOrg(getWebsiteStructuredData());

  if (!siteSettings) {
    return null;
  }

  const cookiesSettings = siteSettings?.cookiesSettings;
  const cookiesPopup = siteSettings?.cookiesPopup;
  const isPreviewMode = isPreviewFromEnv();

  return (
    <>
      {cookiesSettings && (
        <GoogleTagManager gtmId={cookiesSettings.performanceCookiesGTMID} />
      )}

      {cookiesPopup && cookiesSettings && !isPreviewMode && (
        <CookiesPopup
          cookiesPopup={cookiesPopup}
          cookiesSettings={cookiesSettings}
        />
      )}
    </>
  );
};
